export default __webpack_public_path__ + "static/bg-compare-dd02b3dccf8f1ab7a0d2cd8eac11549d.png";